import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { schedule } from '@ember/runloop';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { APIData, PopupData, Service } from 'webapp-types';
import { copyToClipboard, formatObjectArrayAsTextTable } from 'webapp/utils/common';

import BarLoaderComponent from 'webapp/components/bar-loader';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class CommonPopupRequestDiagnosticsComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('request') declare requestService: Service.Request;

	@tracked isLoading: boolean;
	@tracked diagnosticsData: APIData.PlatformAdmin.DiagnosticsRequest[];

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.diagnosticsData = [];
		this.isLoading = true;

		void this.requestService
			.api<APIData.PlatformAdmin.DiagnosticsResponse>('GET', '/platform-admin/diagnostics', {
				requests: 10,
			})
			.then((reply) => {
				// reply = {"requests":[{"createdAt":"2020-08-20 14:00:00","endpoint":"POST /d/boards/","requestId":"123321asd"},{"createdAt":"2020-08-20 14:10:00","endpoint":"GET /d/boards/","requestId":"3215asd12"}]};
				this.diagnosticsData = reply?.requests || [];
				this.isLoading = false;
				schedule('afterRender', this.reposition);
			})
			.catch();
	}

	@action
	copyDiagnosticData() {
		const formattedText = formatObjectArrayAsTextTable(this.diagnosticsData, 4);

		copyToClipboard(formattedText);
		this.infolayerService.ok('Copied to clipboard!');
	}
	<template>
		<div class="title">
			Request diagnostics
		</div>
		<div class="content">

			{{#if this.isLoading}}
				<BarLoaderComponent @size="big" />
			{{else if this.diagnosticsData}}

				<table width="100%" cellspacing="0" cellpadding="0">
					<thead>
						<tr>
							<th>createdAt</th>
							<th>endpoint</th>
							<th>requestId</th>
						</tr>
					</thead>
					<tbody>
						{{#each this.diagnosticsData as |row|}}
							<tr>
								<td>{{row.createdAt}}</td>
								<td>{{row.endpoint}}</td>
								<td>{{row.requestId}}</td>
							</tr>
						{{/each}}
					</tbody>
				</table>
				<div class="controls2">
					<div class="controls2__right">
						<SubmitButtonComponent
							@text="Copy"
							@noDelay={{true}}
							@onTrigger={{this.copyDiagnosticData}}
						/>
					</div>
				</div>

			{{else}}
				<p>No data returned.</p>
			{{/if}}

		</div>
	</template>
}
